import _definePage_default_0 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/conversion-path/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/explorer-conversion-path.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/product-analytics/index.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/index.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/goal-first.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/index.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step0.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step1.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step2.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step3.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step4.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/[...path].vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/access-denied',
    name: '/access-denied',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/access-denied.vue'),
    /* no children */
  },
  {
    path: '/ai-agent',
    /* internal name: '/ai-agent' */
    /* no component */
    children: [
      {
        path: '',
        name: '/ai-agent/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ai-agent/index.vue'),
        /* no children */
      },
      {
        path: 'cart-abandonment-agent',
        /* internal name: '/ai-agent/cart-abandonment-agent' */
        /* no component */
        children: [
          {
            path: '',
            name: '/ai-agent/cart-abandonment-agent/',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ai-agent/cart-abandonment-agent/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'chat',
        name: '/ai-agent/chat',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ai-agent/chat.vue'),
        /* no children */
      },
      {
        path: 'explorer-chat',
        name: '/ai-agent/explorer-chat',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ai-agent/explorer-chat.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/ai-talk',
    /* internal name: '/ai-talk' */
    /* no component */
    children: [
      {
        path: '',
        name: '/ai-talk/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ai-talk/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/ally-claw',
    /* internal name: '/ally-claw' */
    /* no component */
    children: [
      {
        path: '',
        name: '/ally-claw/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ally-claw/index.vue'),
        /* no children */
      },
      {
        path: 'chat',
        /* internal name: '/ally-claw/chat' */
        /* no component */
        children: [
          {
            path: '',
            name: '/ally-claw/chat/',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ally-claw/chat/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'free',
        /* internal name: '/ally-claw/free' */
        /* no component */
        children: [
          {
            path: '',
            name: '/ally-claw/free/',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/ally-claw/free/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/apps',
    /* internal name: '/apps' */
    /* no component */
    children: [
      {
        path: '',
        name: '/apps/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/apps/index.vue'),
        /* no children */
        meta: {
          "auth": true
        }
      }
    ],
  },
  {
    path: '/attribution',
    /* internal name: '/attribution' */
    /* no component */
    children: [
      {
        path: 'ads',
        /* internal name: '/attribution/ads' */
        /* no component */
        children: [
          {
            path: '',
            name: '/attribution/ads/',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/ads/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'ads-automation',
        name: '/attribution/ads-automation',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/ads-automation.vue'),
        /* no children */
      },
      {
        path: 'all',
        name: '/attribution/all',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/all.vue'),
        /* no children */
      },
      {
        path: 'conversion-path',
        /* internal name: '/attribution/conversion-path' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/attribution/conversion-path/',
              component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/conversion-path/index.vue'),
              /* no children */
            },
            _definePage_default_0
          )
        ],
      },
      {
        path: 'conversion-paths',
        name: '/attribution/conversion-paths',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/conversion-paths.vue'),
        /* no children */
      },
      {
        path: 'creatives',
        name: '/attribution/creatives',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/creatives.vue'),
        /* no children */
      },
      {
        path: 'explorer-ads',
        name: '/attribution/explorer-ads',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/explorer-ads.vue'),
        /* no children */
      },
      {
        path: 'explorer-all',
        name: '/attribution/explorer-all',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/explorer-all.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'explorer-conversion-path',
          name: '/attribution/explorer-conversion-path',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/explorer-conversion-path.vue'),
          /* no children */
        },
        _definePage_default_2
      ),
      {
        path: 'explorer-web-analysis',
        name: '/attribution/explorer-web-analysis',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/explorer-web-analysis.vue'),
        /* no children */
      },
      {
        path: 'product-analytics',
        /* internal name: '/attribution/product-analytics' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/attribution/product-analytics/',
              component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/product-analytics/index.vue'),
              /* no children */
            },
            _definePage_default_3
          ),
          {
            path: 'detail',
            name: '/attribution/product-analytics/detail',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/product-analytics/detail.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'web-analysis',
        name: '/attribution/web-analysis',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/web-analysis.vue'),
        /* no children */
      },
      {
        path: 'web-analysis-v1',
        name: '/attribution/web-analysis-v1',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/attribution/web-analysis-v1.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth.vue'),
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/index.vue'),
        /* no children */
      },
      {
        path: 'forgot-password',
        name: '/auth/forgot-password',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/forgot-password.vue'),
        /* no children */
      },
      {
        path: 'otp',
        name: '/auth/otp',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/otp.vue'),
        /* no children */
      },
      {
        path: 'shopify-callback',
        name: '/auth/shopify-callback',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/shopify-callback.vue'),
        /* no children */
        meta: {
          "layout": false,
          "auth": false
        }
      },
      {
        path: 'sign-in',
        name: '/auth/sign-in',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/sign-in.vue'),
        /* no children */
      },
      {
        path: 'sign-in-2',
        name: '/auth/sign-in-2',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/sign-in-2.vue'),
        /* no children */
      },
      {
        path: 'sign-in-dev',
        name: '/auth/sign-in-dev',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/sign-in-dev.vue'),
        /* no children */
      },
      {
        path: 'sign-up',
        name: '/auth/sign-up',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/sign-up.vue'),
        /* no children */
      },
      {
        path: 'woo',
        name: '/auth/woo',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/woo.vue'),
        /* no children */
      },
      {
        path: 'woo-checking',
        name: '/auth/woo-checking',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/auth/woo-checking.vue'),
        /* no children */
      }
    ],
    meta: {
      "layout": false
    }
  },
  {
    path: '/benchmarks',
    /* internal name: '/benchmarks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/benchmarks/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/benchmarks/index.vue'),
        /* no children */
      },
      {
        path: 'public',
        name: '/benchmarks/public',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/benchmarks/public.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/billing',
    /* internal name: '/billing' */
    /* no component */
    children: [
      {
        path: '',
        name: '/billing/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/billing/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/billing-recapture',
    /* internal name: '/billing-recapture' */
    /* no component */
    children: [
      {
        path: '',
        name: '/billing-recapture/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/billing-recapture/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/billing-retention',
    /* internal name: '/billing-retention' */
    /* no component */
    children: [
      {
        path: '',
        name: '/billing-retention/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/billing-retention/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/billing-v1',
    /* internal name: '/billing-v1' */
    /* no component */
    children: [
      {
        path: '',
        name: '/billing-v1/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/billing-v1/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/capture',
    /* internal name: '/capture' */
    /* no component */
    children: [
      {
        path: '',
        name: '/capture/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/capture/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/conversion-feed',
    /* internal name: '/conversion-feed' */
    /* no component */
    children: [
      {
        path: '',
        name: '/conversion-feed/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/index.vue'),
        /* no children */
      },
      {
        path: 'activecampaign',
        name: '/conversion-feed/activecampaign',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/activecampaign.vue'),
        /* no children */
      },
      {
        path: 'app-embed-preview',
        name: '/conversion-feed/app-embed-preview',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/app-embed-preview.vue'),
        /* no children */
      },
      {
        path: 'awin',
        name: '/conversion-feed/awin',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/awin.vue'),
        /* no children */
      },
      {
        path: 'bing',
        name: '/conversion-feed/bing',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/bing.vue'),
        /* no children */
      },
      {
        path: 'bing-embed',
        name: '/conversion-feed/bing-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/bing-embed.vue'),
        /* no children */
      },
      {
        path: 'cartsee',
        name: '/conversion-feed/cartsee',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/cartsee.vue'),
        /* no children */
      },
      {
        path: 'cartsee-embed',
        name: '/conversion-feed/cartsee-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/cartsee-embed.vue'),
        /* no children */
      },
      {
        path: 'cybertargeter',
        name: '/conversion-feed/cybertargeter',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/cybertargeter.vue'),
        /* no children */
      },
      {
        path: 'data-report',
        name: '/conversion-feed/data-report',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/data-report.vue'),
        /* no children */
      },
      {
        path: 'destinations',
        name: '/conversion-feed/destinations',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/destinations.vue'),
        /* no children */
      },
      {
        path: 'destinations-v1',
        name: '/conversion-feed/destinations-v1',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/destinations-v1.vue'),
        /* no children */
      },
      {
        path: 'ga4',
        name: '/conversion-feed/ga4',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/ga4.vue'),
        /* no children */
      },
      {
        path: 'ga4-embed',
        name: '/conversion-feed/ga4-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/ga4-embed.vue'),
        /* no children */
      },
      {
        path: 'google',
        name: '/conversion-feed/google',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/google.vue'),
        /* no children */
      },
      {
        path: 'google-customer-list',
        name: '/conversion-feed/google-customer-list',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/google-customer-list.vue'),
        /* no children */
      },
      {
        path: 'google-embed',
        name: '/conversion-feed/google-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/google-embed.vue'),
        /* no children */
      },
      {
        path: 'google-old',
        name: '/conversion-feed/google-old',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/google-old.vue'),
        /* no children */
      },
      {
        path: 'impact',
        name: '/conversion-feed/impact',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/impact.vue'),
        /* no children */
      },
      {
        path: 'impact-embed',
        name: '/conversion-feed/impact-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/impact-embed.vue'),
        /* no children */
      },
      {
        path: 'klaviyo',
        name: '/conversion-feed/klaviyo',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/klaviyo.vue'),
        /* no children */
      },
      {
        path: 'klaviyo-embed',
        name: '/conversion-feed/klaviyo-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/klaviyo-embed.vue'),
        /* no children */
      },
      {
        path: 'manba',
        name: '/conversion-feed/manba',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/manba.vue'),
        /* no children */
      },
      {
        path: 'manba-embed',
        name: '/conversion-feed/manba-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/manba-embed.vue'),
        /* no children */
      },
      {
        path: 'meta',
        name: '/conversion-feed/meta',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/meta.vue'),
        children: [
          {
            path: 'app-embed-preview',
            name: '/conversion-feed/meta/app-embed-preview',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/meta/app-embed-preview.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'meta-custom-audiences',
        name: '/conversion-feed/meta-custom-audiences',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/meta-custom-audiences.vue'),
        /* no children */
      },
      {
        path: 'meta-embed',
        name: '/conversion-feed/meta-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/meta-embed.vue'),
        /* no children */
      },
      {
        path: 'meta-old',
        name: '/conversion-feed/meta-old',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/meta-old.vue'),
        /* no children */
      },
      {
        path: 'omnisend',
        name: '/conversion-feed/omnisend',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/omnisend.vue'),
        /* no children */
      },
      {
        path: 'omnisend-embed',
        name: '/conversion-feed/omnisend-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/omnisend-embed.vue'),
        /* no children */
      },
      {
        path: 'omnisend-segment',
        name: '/conversion-feed/omnisend-segment',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/omnisend-segment.vue'),
        /* no children */
      },
      {
        path: 'shareasale',
        name: '/conversion-feed/shareasale',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/shareasale.vue'),
        /* no children */
      },
      {
        path: 'shareasale-embed',
        name: '/conversion-feed/shareasale-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/shareasale-embed.vue'),
        /* no children */
      },
      {
        path: 'shopify-segment',
        name: '/conversion-feed/shopify-segment',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/shopify-segment.vue'),
        /* no children */
      },
      {
        path: 'shopline-segment',
        name: '/conversion-feed/shopline-segment',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/shopline-segment.vue'),
        /* no children */
      },
      {
        path: 'snapchat',
        name: '/conversion-feed/snapchat',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/snapchat.vue'),
        /* no children */
      },
      {
        path: 'snapchat-embed',
        name: '/conversion-feed/snapchat-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/snapchat-embed.vue'),
        /* no children */
      },
      {
        path: 'tiktok',
        name: '/conversion-feed/tiktok',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/tiktok.vue'),
        /* no children */
      },
      {
        path: 'tiktok-embed',
        name: '/conversion-feed/tiktok-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/tiktok-embed.vue'),
        /* no children */
      },
      {
        path: 'webhook',
        name: '/conversion-feed/webhook',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/conversion-feed/webhook.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/custom-store',
    /* internal name: '/custom-store' */
    /* no component */
    children: [
      {
        path: 'step1',
        name: '/custom-store/step1',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/custom-store/step1.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: 'step2',
        name: '/custom-store/step2',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/custom-store/step2.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: 'step3',
        name: '/custom-store/step3',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/custom-store/step3.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      }
    ],
  },
  {
    path: '/dashboard',
    /* internal name: '/dashboard' */
    /* no component */
    children: [
      {
        path: '',
        name: '/dashboard/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/dashboard/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dashboard-layout-demo',
    name: '/dashboard-layout-demo',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/dashboard-layout-demo.vue'),
    /* no children */
    meta: {
      "layout": "dashboard"
    }
  },
  {
    path: '/dashboard-test',
    name: '/dashboard-test',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/dashboard-test.vue'),
    /* no children */
  },
  {
    path: '/date-picker-demo',
    name: '/date-picker-demo',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/date-picker-demo.vue'),
    /* no children */
  },
  {
    path: '/demo',
    /* internal name: '/demo' */
    /* no component */
    children: [
      {
        path: 'date-picker-test',
        name: '/demo/date-picker-test',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/demo/date-picker-test.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dev',
    /* internal name: '/dev' */
    /* no component */
    children: [
      {
        path: 'overlay-scope',
        name: '/dev/overlay-scope',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/dev/overlay-scope.vue'),
        /* no children */
        meta: {
          "auth": false
        }
      }
    ],
  },
  {
    path: '/dual-axis-chart-demo',
    name: '/dual-axis-chart-demo',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/dual-axis-chart-demo.vue'),
    /* no children */
  },
  {
    path: '/errors',
    name: '/errors',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors.vue'),
    children: [
      {
        path: '',
        name: '/errors/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors/index.vue'),
        /* no children */
      },
      {
        path: '401',
        name: '/errors/401',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors/401.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '403',
        name: '/errors/403',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors/403.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '404',
        name: '/errors/404',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors/404.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '500',
        name: '/errors/500',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors/500.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '503',
        name: '/errors/503',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors/503.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: 'access-denied',
        name: '/errors/access-denied',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/errors/access-denied.vue'),
        /* no children */
        meta: {
          "layout": "default"
        }
      }
    ],
    meta: {
      "layout": false
    }
  },
  {
    path: '/explorer-influencer',
    name: '/explorer-influencer',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/explorer-influencer.vue'),
    /* no children */
  },
  {
    path: '/explorer-link-builder',
    name: '/explorer-link-builder',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/explorer-link-builder.vue'),
    /* no children */
  },
  {
    path: '/feature-request',
    name: '/feature-request',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/feature-request.vue'),
    /* no children */
  },
  {
    path: '/get-started',
    /* internal name: '/get-started' */
    /* no component */
    children: [
      {
        path: '',
        name: '/get-started/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/get-started/index.vue'),
        /* no children */
        meta: {
          "auth": false
        }
      }
    ],
  },
  {
    path: '/getting-started',
    /* internal name: '/getting-started' */
    /* no component */
    children: [
      {
        path: '',
        name: '/getting-started/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/getting-started/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/help-center',
    name: '/help-center',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/help-center.vue'),
    /* no children */
  },
  {
    path: '/home',
    /* internal name: '/home' */
    /* no component */
    children: [
      {
        path: '',
        name: '/home/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/home/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/icon-demo',
    name: '/icon-demo',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/icon-demo.vue'),
    /* no children */
  },
  {
    path: '/influencer',
    /* internal name: '/influencer' */
    /* no component */
    children: [
      {
        path: '',
        name: '/influencer/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/influencer/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/influencers',
    name: '/influencers',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/influencers.vue'),
    /* no children */
  },
  {
    path: '/integrations',
    /* internal name: '/integrations' */
    /* no component */
    children: [
      {
        path: '',
        name: '/integrations/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/index.vue'),
        /* no children */
        meta: {
          "auth": false
        }
      },
      {
        path: 'activecampaign',
        name: '/integrations/activecampaign',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/activecampaign.vue'),
        /* no children */
      },
      {
        path: 'applovin',
        name: '/integrations/applovin',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/applovin.vue'),
        /* no children */
      },
      {
        path: 'applovin-embed',
        name: '/integrations/applovin-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/applovin-embed.vue'),
        /* no children */
      },
      {
        path: 'awin',
        name: '/integrations/awin',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/awin.vue'),
        /* no children */
      },
      {
        path: 'bing',
        name: '/integrations/bing',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/bing.vue'),
        /* no children */
      },
      {
        path: 'bing-embed',
        name: '/integrations/bing-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/bing-embed.vue'),
        /* no children */
      },
      {
        path: 'calltrackingmetrics',
        name: '/integrations/calltrackingmetrics',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/calltrackingmetrics.vue'),
        /* no children */
      },
      {
        path: 'calltrackingmetrics-embed',
        name: '/integrations/calltrackingmetrics-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/calltrackingmetrics-embed.vue'),
        /* no children */
      },
      {
        path: 'cartsee',
        name: '/integrations/cartsee',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/cartsee.vue'),
        /* no children */
      },
      {
        path: 'criteo',
        name: '/integrations/criteo',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/criteo.vue'),
        /* no children */
      },
      {
        path: 'goaffpro',
        name: '/integrations/goaffpro',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/goaffpro.vue'),
        /* no children */
      },
      {
        path: 'google',
        name: '/integrations/google',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/google.vue'),
        /* no children */
      },
      {
        path: 'google-embed',
        name: '/integrations/google-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/google-embed.vue'),
        /* no children */
      },
      {
        path: 'impact',
        name: '/integrations/impact',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/impact.vue'),
        /* no children */
      },
      {
        path: 'impact-embed',
        name: '/integrations/impact-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/impact-embed.vue'),
        /* no children */
      },
      {
        path: 'klaviyo',
        name: '/integrations/klaviyo',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/klaviyo.vue'),
        /* no children */
      },
      {
        path: 'klaviyo-embed',
        name: '/integrations/klaviyo-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/klaviyo-embed.vue'),
        /* no children */
      },
      {
        path: 'linkedin',
        name: '/integrations/linkedin',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/linkedin.vue'),
        /* no children */
      },
      {
        path: 'linkedin-embed',
        name: '/integrations/linkedin-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/linkedin-embed.vue'),
        /* no children */
      },
      {
        path: 'looker_studio',
        name: '/integrations/looker_studio',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/looker_studio.vue'),
        /* no children */
      },
      {
        path: 'mailchimp',
        name: '/integrations/mailchimp',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/mailchimp.vue'),
        /* no children */
      },
      {
        path: 'manba',
        name: '/integrations/manba',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/manba.vue'),
        /* no children */
      },
      {
        path: 'meta',
        name: '/integrations/meta',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/meta.vue'),
        /* no children */
      },
      {
        path: 'meta-embed',
        name: '/integrations/meta-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/meta-embed.vue'),
        /* no children */
      },
      {
        path: 'oauth',
        /* internal name: '/integrations/oauth' */
        /* no component */
        children: [
          {
            path: 'callback',
            name: '/integrations/oauth/callback',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/oauth/callback.vue'),
            /* no children */
          },
          {
            path: 'shopline-callback',
            name: '/integrations/oauth/shopline-callback',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/oauth/shopline-callback.vue'),
            /* no children */
            meta: {
              "auth": false
            }
          }
        ],
      },
      {
        path: 'omnisend',
        name: '/integrations/omnisend',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/omnisend.vue'),
        /* no children */
      },
      {
        path: 'omnisend-embed',
        name: '/integrations/omnisend-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/omnisend-embed.vue'),
        /* no children */
      },
      {
        path: 'pinterest',
        name: '/integrations/pinterest',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/pinterest.vue'),
        /* no children */
      },
      {
        path: 'pinterest-embed',
        name: '/integrations/pinterest-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/pinterest-embed.vue'),
        /* no children */
      },
      {
        path: 'quora',
        name: '/integrations/quora',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/quora.vue'),
        /* no children */
      },
      {
        path: 'shareasale',
        name: '/integrations/shareasale',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/shareasale.vue'),
        /* no children */
      },
      {
        path: 'shareasale-embed',
        name: '/integrations/shareasale-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/shareasale-embed.vue'),
        /* no children */
      },
      {
        path: 'shopify',
        name: '/integrations/shopify',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/shopify.vue'),
        /* no children */
        meta: {
          "auth": false,
          "layout": "blank"
        }
      },
      {
        path: 'shopline',
        name: '/integrations/shopline',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/shopline.vue'),
        /* no children */
        meta: {
          "auth": false
        }
      },
      {
        path: 'snapchat',
        name: '/integrations/snapchat',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/snapchat.vue'),
        /* no children */
      },
      {
        path: 'snapchat-embed',
        name: '/integrations/snapchat-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/snapchat-embed.vue'),
        /* no children */
      },
      {
        path: 'sources',
        name: '/integrations/sources',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/sources.vue'),
        /* no children */
      },
      {
        path: 'tiktok',
        name: '/integrations/tiktok',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/tiktok.vue'),
        /* no children */
      },
      {
        path: 'tiktok-embed',
        name: '/integrations/tiktok-embed',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/tiktok-embed.vue'),
        /* no children */
      },
      {
        path: 'twitter',
        name: '/integrations/twitter',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/twitter.vue'),
        /* no children */
      },
      {
        path: 'uppromote',
        name: '/integrations/uppromote',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/uppromote.vue'),
        /* no children */
      },
      {
        path: 'woocommerce',
        /* internal name: '/integrations/woocommerce' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/integrations/woocommerce/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/woocommerce/step1.vue'),
            /* no children */
            meta: {
              "layout": "blank"
            }
          },
          {
            path: 'step2',
            name: '/integrations/woocommerce/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/integrations/woocommerce/step2.vue'),
            /* no children */
            meta: {
              "layout": "blank"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/link-builder',
    /* internal name: '/link-builder' */
    /* no component */
    children: [
      {
        path: '',
        name: '/link-builder/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/link-builder/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/live-events',
    /* internal name: '/live-events' */
    /* no component */
    children: [
      {
        path: '',
        name: '/live-events/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/live-events/index.vue'),
        /* no children */
        meta: {
          "auth": true
        }
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "blank"
    }
  },
  {
    path: '/login-invite',
    name: '/login-invite',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/login-invite.vue'),
    /* no children */
    meta: {
      "layout": "blank"
    }
  },
  {
    path: '/marketing',
    /* internal name: '/marketing' */
    /* no component */
    children: [
      {
        path: '',
        name: '/marketing/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/marketing/index.vue'),
        /* no children */
        meta: {
          "layout": "marketing"
        }
      },
      {
        path: 'hello',
        name: '/marketing/hello',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/marketing/hello.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/oauth',
    /* internal name: '/oauth' */
    /* no component */
    children: [
      {
        path: 'consent',
        name: '/oauth/consent',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/oauth/consent.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      }
    ],
  },
  {
    path: '/onboarding',
    name: '/onboarding',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding.vue'),
    children: [
      {
        path: ':platform-steps',
        /* internal name: '/onboarding/[platform]-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/[platform]-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/[platform]-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/[platform]-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/[platform]-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      _mergeRouteRecord(
        {
          path: '/__onboarding-source-legacy',
          name: '/onboarding/',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/index.vue'),
          /* no children */
        },
        _definePage_default_4
      ),
      _mergeRouteRecord(
        {
          path: '/onboarding',
          name: '/onboarding/goal-first',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/goal-first.vue'),
          /* no children */
        },
        _definePage_default_5
      ),
      {
        path: 'applovin-steps',
        /* internal name: '/onboarding/applovin-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/applovin-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/applovin-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'bing-steps',
        /* internal name: '/onboarding/bing-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/bing-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/bing-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'calltrackingmetrics-steps',
        /* internal name: '/onboarding/calltrackingmetrics-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/calltrackingmetrics-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/calltrackingmetrics-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'de-anonymize-steps',
        /* internal name: '/onboarding/de-anonymize-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/de-anonymize-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/de-anonymize-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/de-anonymize-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/de-anonymize-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'ga4-steps',
        /* internal name: '/onboarding/ga4-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/ga4-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/ga4-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/ga4-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/ga4-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'goal-steps',
        /* internal name: '/onboarding/goal-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/goal-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/goal-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/goal-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/goal-steps/step2.vue'),
            /* no children */
          },
          {
            path: 'step3',
            name: '/onboarding/goal-steps/step3',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/goal-steps/step3.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'google-steps',
        /* internal name: '/onboarding/google-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/google-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/google-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'impact-steps',
        /* internal name: '/onboarding/impact-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/impact-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/impact-steps/step2.vue'),
            /* no children */
          },
          {
            path: 'step3',
            name: '/onboarding/impact-steps/step3',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/impact-steps/step3.vue'),
            /* no children */
          },
          {
            path: 'step4',
            name: '/onboarding/impact-steps/step4',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/impact-steps/step4.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'influencer-other-steps',
        /* internal name: '/onboarding/influencer-other-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/influencer-other-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/influencer-other-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/influencer-other-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/influencer-other-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'influencer-steps',
        /* internal name: '/onboarding/influencer-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/influencer-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/influencer-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/influencer-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/influencer-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'klaviyo-steps',
        /* internal name: '/onboarding/klaviyo-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/klaviyo-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/klaviyo-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/klaviyo-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/klaviyo-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'linkedin-steps',
        /* internal name: '/onboarding/linkedin-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/linkedin-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/linkedin-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'meta-steps',
        /* internal name: '/onboarding/meta-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/meta-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/meta-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'omnisend-steps',
        /* internal name: '/onboarding/omnisend-steps' */
        /* no component */
        children: [
          {
            path: 'step1',
            name: '/onboarding/omnisend-steps/step1',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/omnisend-steps/step1.vue'),
            /* no children */
          },
          {
            path: 'step2',
            name: '/onboarding/omnisend-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/omnisend-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'pinterest-steps',
        /* internal name: '/onboarding/pinterest-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/pinterest-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/pinterest-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'shareasale-steps',
        /* internal name: '/onboarding/shareasale-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/shareasale-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/shareasale-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'snapchat-steps',
        /* internal name: '/onboarding/snapchat-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/snapchat-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/snapchat-steps/step2.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'tiktok-steps',
        /* internal name: '/onboarding/tiktok-steps' */
        /* no component */
        children: [
          {
            path: 'step2',
            name: '/onboarding/tiktok-steps/step2',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding/tiktok-steps/step2.vue'),
            /* no children */
          }
        ],
      }
    ],
    meta: {
      "layout": false
    }
  },
  {
    path: '/onboarding-retention',
    /* internal name: '/onboarding-retention' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '/onboarding-retention',
          name: '/onboarding-retention/',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/index.vue'),
          /* no children */
        },
        _definePage_default_6
      ),
      _mergeRouteRecord(
        {
          path: '/onboarding-retention/step0',
          name: '/onboarding-retention/step0',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step0.vue'),
          /* no children */
        },
        _definePage_default_7
      ),
      _mergeRouteRecord(
        {
          path: '/onboarding-retention/step1',
          name: '/onboarding-retention/step1',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step1.vue'),
          /* no children */
        },
        _definePage_default_8
      ),
      _mergeRouteRecord(
        {
          path: '/onboarding-retention/step2',
          name: '/onboarding-retention/step2',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step2.vue'),
          /* no children */
        },
        _definePage_default_9
      ),
      _mergeRouteRecord(
        {
          path: '/onboarding-retention/step3',
          name: '/onboarding-retention/step3',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step3.vue'),
          /* no children */
        },
        _definePage_default_10
      ),
      _mergeRouteRecord(
        {
          path: '/onboarding-retention/step4',
          name: '/onboarding-retention/step4',
          component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/onboarding-retention/step4.vue'),
          /* no children */
        },
        _definePage_default_11
      )
    ],
  },
  {
    path: '/post-purchase-survey',
    name: '/post-purchase-survey',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/post-purchase-survey.vue'),
    /* no children */
  },
  {
    path: '/q=source',
    name: '/q=source',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/q=source.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/recapture',
    /* internal name: '/recapture' */
    /* no component */
    children: [
      {
        path: '',
        name: '/recapture/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/recapture/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/recommendations',
    /* internal name: '/recommendations' */
    /* no component */
    children: [
      {
        path: '',
        name: '/recommendations/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/recommendations/index.vue'),
        /* no children */
        meta: {
          "layout": "default",
          "auth": true
        }
      }
    ],
  },
  {
    path: '/refer-us',
    name: '/refer-us',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/refer-us.vue'),
    /* no children */
  },
  {
    path: '/reports-library',
    /* internal name: '/reports-library' */
    /* no component */
    children: [
      {
        path: '',
        name: '/reports-library/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/reports-library/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/select-store',
    name: '/select-store',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/select-store.vue'),
    /* no children */
    meta: {
      "auth": false,
      "layout": "blank"
    }
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: '/settings/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/index.vue'),
        /* no children */
      },
      {
        path: 'aan',
        name: '/settings/aan',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/aan.vue'),
        /* no children */
      },
      {
        path: 'account',
        name: '/settings/account',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/account.vue'),
        /* no children */
      },
      {
        path: 'api-keys',
        name: '/settings/api-keys',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/api-keys.vue'),
        /* no children */
      },
      {
        path: 'attribution-model',
        /* internal name: '/settings/attribution-model' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/attribution-model/',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/attribution-model/index.vue'),
            /* no children */
          },
          {
            path: 'add-custom',
            name: '/settings/attribution-model/add-custom',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/attribution-model/add-custom.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'capture',
        name: '/settings/capture',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/capture.vue'),
        /* no children */
      },
      {
        path: 'channel-group',
        name: '/settings/channel-group',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/channel-group.vue'),
        /* no children */
      },
      {
        path: 'conversion-goals',
        name: '/settings/conversion-goals',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/conversion-goals.vue'),
        /* no children */
      },
      {
        path: 'cost-settings',
        name: '/settings/cost-settings',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/cost-settings.vue'),
        /* no children */
      },
      {
        path: 'custom-domain',
        name: '/settings/custom-domain',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/custom-domain.vue'),
        /* no children */
      },
      {
        path: 'exclusion-list',
        name: '/settings/exclusion-list',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/exclusion-list.vue'),
        /* no children */
      },
      {
        path: 'general',
        name: '/settings/general',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/general.vue'),
        /* no children */
      },
      {
        path: 'intent-tag',
        /* internal name: '/settings/intent-tag' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/intent-tag/',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/index.vue'),
            /* no children */
          },
          {
            path: 'annotation',
            name: '/settings/intent-tag/annotation',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/annotation.vue'),
            /* no children */
          },
          {
            path: 'concerns',
            name: '/settings/intent-tag/concerns',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/concerns.vue'),
            /* no children */
          },
          {
            path: 'eval',
            name: '/settings/intent-tag/eval',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/eval.vue'),
            /* no children */
          },
          {
            path: 'intent',
            name: '/settings/intent-tag/intent',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/intent.vue'),
            /* no children */
          },
          {
            path: 'jtbd',
            name: '/settings/intent-tag/jtbd',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/jtbd.vue'),
            /* no children */
          },
          {
            path: 'profiling',
            name: '/settings/intent-tag/profiling',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/profiling.vue'),
            /* no children */
          },
          {
            path: 'samples',
            name: '/settings/intent-tag/samples',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/samples.vue'),
            /* no children */
          },
          {
            path: 'verify',
            name: '/settings/intent-tag/verify',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/intent-tag/verify.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'labs',
        name: '/settings/labs',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/labs.vue'),
        /* no children */
      },
      {
        path: 'notifications',
        name: '/settings/notifications',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/notifications.vue'),
        /* no children */
      },
      {
        path: 'pixel-setting',
        name: '/settings/pixel-setting',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/settings/pixel-setting.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/store',
    /* internal name: '/store' */
    /* no component */
    children: [
      {
        path: 'customer-details',
        name: '/store/customer-details',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/customer-details.vue'),
        children: [
          {
            path: ':id',
            name: '/store/customer-details/[id]',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/customer-details/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'customer-profile',
        /* internal name: '/store/customer-profile' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/store/customer-profile/[id]',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/customer-profile/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'customers',
        name: '/store/customers',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/customers.vue'),
        /* no children */
      },
      {
        path: 'explorer-customers',
        name: '/store/explorer-customers',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/explorer-customers.vue'),
        /* no children */
      },
      {
        path: 'explorer-orders',
        name: '/store/explorer-orders',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/explorer-orders.vue'),
        /* no children */
      },
      {
        path: 'new-segment',
        name: '/store/new-segment',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/new-segment.vue'),
        /* no children */
      },
      {
        path: 'order-details',
        name: '/store/order-details',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/order-details.vue'),
        /* no children */
      },
      {
        path: 'orders',
        name: '/store/orders',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/orders.vue'),
        /* no children */
      },
      {
        path: 'products',
        name: '/store/products',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/products.vue'),
        /* no children */
      },
      {
        path: 'segment',
        /* internal name: '/store/segment' */
        /* no component */
        children: [
          {
            path: 'data-report',
            /* internal name: '/store/segment/data-report' */
            /* no component */
            children: [
              {
                path: ':id',
                name: '/store/segment/data-report/[id]',
                component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/segment/data-report/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'segment-customers',
        /* internal name: '/store/segment-customers' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/store/segment-customers/[id]',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/segment-customers/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'segment-form',
        name: '/store/segment-form',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/segment-form.vue'),
        /* no children */
      },
      {
        path: 'segment-orders',
        /* internal name: '/store/segment-orders' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/store/segment-orders/[id]',
            component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/segment-orders/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'segments',
        name: '/store/segments',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/segments.vue'),
        /* no children */
      },
      {
        path: 'segments-v1',
        name: '/store/segments-v1',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/store/segments-v1.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/tasks',
    /* internal name: '/tasks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/tasks/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/tasks/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test-direct-import',
    name: '/test-direct-import',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/test-direct-import.vue'),
    /* no children */
  },
  {
    path: '/test-icons',
    name: '/test-icons',
    component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/test-icons.vue'),
    /* no children */
  },
  {
    path: '/users',
    /* internal name: '/users' */
    /* no component */
    children: [
      {
        path: '',
        name: '/users/',
        component: () => import('/Users/donyzhang/Desktop/dealmap/www/ecom-attribuly-tmp/src/pages/users/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

